import React from 'react';
import { motion } from 'framer-motion';
export function ArticleIntro() {
  return <section className="max-w-editorial mx-auto px-4 py-8 md:py-12" data-id="element-57">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} className="space-y-6 text-lg leading-relaxed text-charcoal/90" data-id="element-58">
        <p data-id="element-59">
          Wenn du schon Rosmarinöl, Biotin-Gummis und drei verschiedene Shampoos
          ausprobiert hast – und dein Haar trotzdem jeden Monat dünner aussieht
          – dann ist dieser Text für dich.
        </p>
        <p data-id="element-60">
          Du hast dich damit beschäftigt. Du gehörst nicht zu den Frauen, die
          einfach irgendein Produkt kaufen, ohne vorher zu schauen, was drin
          ist.
        </p>
        <p data-id="element-61">
          Du hast die Reddit-Threads gelesen. Du folgst den
          Dermatologen-Accounts. Du hast die Öle, die Seren, die
          Nahrungsergänzungsmittel mit den klinisch klingenden Namen und langen
          Inhaltsstofflisten gekauft.
        </p>
        <p className="font-semibold text-xl font-heading" data-id="element-62">
          Und trotzdem – dein Scheitel wird breiter.
        </p>
        <p data-id="element-63">
          Du zählst immer noch die Haare im Abfluss. Du überlegst immer noch
          zweimal, wie du dein Haar bei hellem Licht trägst. Du beobachtest, wie
          der Pferdeschwanz, der früher so voll war, mit jeder Jahreszeit ein
          bisschen dünner wird.
        </p>
        <p data-id="element-64">
          Es liegt nicht daran, dass du zu früh aufgegeben hast. Und nicht
          daran, dass du nicht genug versucht hast.
        </p>
        <p className="font-semibold text-xl font-heading text-accent" data-id="element-65">
          Das Problem ist: Das meiste, was du über Haarausfall gehört hast,
          zeigt in die falsche Richtung.
        </p>
        <p data-id="element-66">
          Hier sind fünf Dinge, die die Haarausfall-Branche falsch macht – und
          wie ein anderer Ansatz aussieht, wenn man sie korrigiert.
        </p>
      </motion.div>
    </section>;
}